import type { SortDirection } from '@/api/gridTypes';

import { onActivateKey } from './activate';
import { cx } from './classNames';
import type { SimpleTableColumn } from './SimpleTable';

/** Spaltenbreiten für Kopf- und Inhaltstabelle — hält beide deckungsgleich. */
export function SimpleTableColGroup<T>(props: { columns: SimpleTableColumn<T>[] }) {
  return (
    <colgroup>
      {props.columns.map((column) => (
        <col
          key={column.field}
          style={column.width === undefined ? undefined : { width: column.width }}
        />
      ))}
    </colgroup>
  );
}

export interface SimpleTableHeaderProps<T> {
  columns: SimpleTableColumn<T>[];
  sort: { field: string; direction: SortDirection } | null;
  onToggleSort: (field: string) => void;
}

export function SimpleTableHeader<T>(props: SimpleTableHeaderProps<T>) {
  const { sort } = props;

  return (
    <div className="e-gridheader">
      <table className="e-table">
        <SimpleTableColGroup columns={props.columns} />
        <thead>
          <tr>
            {/* Die Kopfzelle schaltet die Sortierung; ohne Tabstopp und
                Enter/Space wäre Sortieren ohne Maus nicht möglich. */}
            {props.columns.map((column) => (
              <th
                key={column.field}
                tabIndex={0}
                className="e-headercell e-mousepointer"
                aria-sort={sort?.field === column.field ? sort.direction : 'none'}
                onClick={() => {
                  props.onToggleSort(column.field);
                }}
                onKeyDown={onActivateKey(() => {
                  props.onToggleSort(column.field);
                })}
              >
                <div className="e-headercelldiv">
                  <span className="e-headertext">{column.headerText ?? column.field}</span>
                </div>
                {sort?.field === column.field ? (
                  <span
                    className={cx(
                      'e-sortfilterdiv',
                      'e-icons',
                      sort.direction === 'ascending'
                        ? 'fa-solid fa-arrow-up-long'
                        : 'fa-solid fa-arrow-down-long',
                    )}
                  />
                ) : null}
              </th>
            ))}
          </tr>
        </thead>
      </table>
    </div>
  );
}

export default SimpleTableHeader;
